import { combineReducers } from "@reduxjs/toolkit";
import auth from "./auth";
import entities from "./entities";

export default combineReducers({
    auth,
    entities
});